import { CallbackComponent } from './shared/callback/callback.component';
import { HomeComponent } from './shared/home/home.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule.forRoot([
      /* define app module routes here, e.g., to lazily load a module
         (do not place feature module routes here, use an own -routing.module.ts in the feature instead)
       */
      {
        path: '',
        // redirectTo: 'home',
        // pathMatch: 'full',
        component: HomeComponent
      },
      {
        path: 'home',
        // redirectTo: 'home',
        // pathMatch: 'full',
        component: HomeComponent
      },
      {
        path: 'callback',
        // redirectTo: 'home',
        // pathMatch: 'full',
        component: CallbackComponent
      }
    ])
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }




// WEBPACK FOOTER //
// /ng-app/src/app/app.routing.ts